import React from "react";
import { Segment } from "@ofqual/portal-core/core/utils/listHelpers";
import { LinkedRecordViewModel } from "../domain/LinkedRecordViewModel";
import { LinkedRecordItem } from "./LinkedRecordItem";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  header: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "1.2em",
    color: theme.palette.grey[700],
    marginTop: 15,
  },
}));

export type LinkedRecordsListSegmentProps = {
  segment: Segment<LinkedRecordViewModel>;
  entityId: string;
};

export const LinkedRecordsListSegment: React.FC<LinkedRecordsListSegmentProps> = ({
  segment,
  entityId,
}) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>{segment.label} - {segment.data.length}</div>
      <div>
        {segment.data.map((viewModel) => (
          <LinkedRecordItem
            key={viewModel.id}
            viewModel={viewModel}
            entityReferenceId={entityId}
          />
        ))}
      </div>
    </>
  );
};
